import { NFIB_THEME_ASSET_ORIGIN } from './nfibPublicSite';

/** Theme images always load from the asset origin (default: production nfib.com). */
export const NFIB_THEME_IMG = `${NFIB_THEME_ASSET_ORIGIN}/wp-content/themes/nfib/resources/images`;

/**
 * Vendored copy of nfib.com marketing Tailwind bundle (packages/client/public/nfib-marketing-theme.css).
 * Re-download that file when the marketing theme changes (see file header comment).
 */
export function getNfibPublicThemeCssUrl() {
  const base =
    typeof window !== 'undefined' && window.location && window.location.origin
      ? window.location.origin
      : '';
  const publicPath = process.env.PUBLIC_URL || '';
  const path = `${publicPath}/nfib-marketing-theme.css`.replace(/\/{2,}/g, '/');
  return `${base}${path.startsWith('/') ? path : `/${path}`}`;
}

/** Self-hosted Montserrat for NFIB site chrome shadow DOM (matches nfib.com). */
export function getMontserratFontsCssUrl() {
  const base =
    typeof window !== 'undefined' && window.location && window.location.origin
      ? window.location.origin
      : '';
  const publicPath = process.env.PUBLIC_URL || '';
  const path = `${publicPath}/assets/montserrat-fonts.css`.replace(/\/{2,}/g, '/');
  return `${base}${path.startsWith('/') ? path : `/${path}`}`;
}



// WEBPACK FOOTER //
// ./src/common/components/Layout/NfibSiteChrome/navConfig.js